<template>
    <div class="tabs">
        <div class="tabs__header">
            <div
                v-for="(tab, index) of state.tabs"
                class="tabs__header-item"
                :class="{
                    'tabs__header-item_active': state.currentTab === index
                }"
                :key="tab.name"
                @click="state.currentTab = index"
            >
                <span>{{ tab.name }}</span>
            </div>
        </div>
        <div class="tabs__body">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: "ExpertPanelTabs",
    data() {
        return {
            state: {
                currentTab: 0,
                tabs: [],
                count: 0,
            },
        };
    },
    provide() {
        return {
            state: this.state,
            updateTabs: this.updateTabs,
        };
    },
    methods: {
        updateTabs(newTabs) {
            this.state.tabs = [...newTabs];
        },
    },
    beforeMount() {
        this.state.tabs = [];
        this.state.count = 0;
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/rem';

.tabs {
  &__header {
    display: flex;
    gap: rem(6);
    &-item {
      padding: rem(8) rem(20);
      background: #F6FAFD;
      border-radius: rem(20) rem(20) 0 0;

      font-weight: 400;
      font-size: rem(16);
      line-height: rem(20);
      color: #98A0A9;
      cursor: pointer;
      &_active {
        background: #fff;
        font-weight: 700;
        font-size: rem(16);
        line-height: rem(20);
        color: #4663AB;
      }
    }
  }
  &__body {
    background: #fff;
    padding: rem(40);
    border-radius: 0 rem(16) rem(16) rem(16);
    box-shadow: 0px 0px 16px rgba(70, 99, 171, 0.2);
  }
}
</style>